/* PALADIN drifting letters for info pages, Contact and Shopify's built-in policy pages.
   Any .paladin-drift layer (data-word, data-mode = margins | scatter) gets the word repeated roughly once per screen-height of page,
   using the FULL page height (measured as if every FAQ question were open, so opening questions reveals letters already there).
   - margins, info pages (desktop): letters alternate left / right, each in its own random height slot, at a random spot across the
     margin between the page edge and the text column. Since 20 Oct the layer covers the whole page incl. the white top.
   - margins, built-in policy pages (desktop): same, but the margins are worked out from the page width in CSS (no measuring), so the
     letters can't be misplaced: left = page edge to text column, right = text column to page edge. Since 20 Oct the layer starts at the
     very top (data-top 0; it used to start below the title, when the title sat on a dark band).
   - scatter (Contact only): desktop = Aidan's fixed positions from the placer tool; phones = loose 3 x 3, kept off the form boxes and button.
   - phones/tablets: random across the width, one height slot each.
   Placed once on load (again only if the window width changes).
   Policy pages: adds a POLICIES layer, turns the Terms of Service "OVERVIEW" / "SECTION n - ..." lines into subheadings (display only),
   then reveals the policy text (it's kept hidden until styled, so there's no flash of the old look). */
(function () {
  'use strict';
  var seed = 1;
  function rnd() { var x = Math.sin(seed++ * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function fullHeight(host) {
    var closed = Array.prototype.slice.call(host.querySelectorAll('details:not([open])'));
    closed.forEach(function (d) { d.open = true; });
    var h = host.scrollHeight;
    closed.forEach(function (d) { d.open = false; });
    return h;
  }

  function span(leftCss, yTop, size, ch) {
    var c = rnd(), d = rnd(), a = rnd();
    var dx = (d - 0.5) * 50, dy = -(30 + a * 40), r = (c - 0.5) * 14;
    return '<span style="left:' + leftCss + ';top:' + Math.round(yTop) + 'px;font-size:' + Math.round(size) + 'px;--dx:' + dx.toFixed(1) +
      'px;--dy:' + dy.toFixed(1) + 'px;--r:' + r.toFixed(1) + 'deg;--dur:' + (22 + Math.round(d * 14)) + 's;animation-delay:-' + Math.round(a * 20) + 's">' + ch + '</span>';
  }
  function px(v) { return Math.round(v) + 'px'; }

  function place(layer) {
    var host = layer.parentElement;
    if (!host) return;
    var word = (layer.getAttribute('data-word') || 'PALADIN').replace(/\s+/g, '').toUpperCase().split('');
    if (!word.length) return;
    var mode = layer.getAttribute('data-mode') || 'margins';
    var isPolicy = layer.classList.contains('paladin-drift--policy');
    var top = parseFloat(layer.getAttribute('data-top') || '0') || 0;
    layer.innerHTML = '';
    layer.style.height = '0px';
    layer.style.top = top + 'px';
    var H = Math.max(fullHeight(host) - top, 240);
    layer.style.height = H + 'px';
    var lr = layer.getBoundingClientRect();
    var W = lr.width || host.clientWidth || window.innerWidth;
    var vh = window.innerHeight || 800;
    var narrow = window.innerWidth < 990;
    var reps = Math.max(1, Math.round(H / (vh * 1.1)));
    seed = 7;
    var html = '';
    function sizeNow() { return narrow ? 44 + rnd() * 26 : 60 + rnd() * 44; }
    var k, s, x, y, b;

    if (mode === 'scatter') {
      // Contact only (the only page using scatter).
      if (!narrow) {
        // Desktop: Aidan's fixed positions from the placer tool (x/y = % of the page body below the fade, size in px)
        var FIXED = [
          { c: 'C', x: 19.22, y: 33.47, size: 72 }, { c: 'O', x: 3.82, y: 32.15, size: 99 }, { c: 'N', x: 76.53, y: 46.87, size: 93 },
          { c: 'T', x: 14.71, y: 7.65, size: 60 }, { c: 'A', x: 59.39, y: 82.4, size: 70 }, { c: 'C', x: 81.22, y: 15.41, size: 83 },
          { c: 'T', x: 10.97, y: 40.27, size: 70 }, { c: 'U', x: 91.04, y: 69.21, size: 74 }, { c: 'S', x: 64.25, y: 71.83, size: 64 }
        ];
        for (k = 0; k < FIXED.length; k++) {
          rnd(); rnd(); rnd(); // keep each letter's own drift values varied
          html += span(FIXED[k].x + '%', FIXED[k].y / 100 * H, FIXED[k].size, FIXED[k].c);
        }
      } else {
        // Phones: loose 3 x 3 (C O N / T A C / T U S), each letter at a random spot in its own cell, kept off the form boxes and button
        var avoid = [];
        Array.prototype.slice.call(host.querySelectorAll('.pip-fm input, .pip-fm textarea, .pip-fm .pip-btn')).forEach(function (el) {
          var r = el.getBoundingClientRect();
          avoid.push([r.left - lr.left - 10, r.top - lr.top - 10, r.right - lr.left + 10, r.bottom - lr.top + 10]);
        });
        var blocked = function (bx, by, bs) {
          for (var i = 0; i < avoid.length; i++) {
            var q = avoid[i];
            if (bx + bs * 0.75 > q[0] && bx < q[2] && by + bs > q[1] && by < q[3]) return true;
          }
          return false;
        };
        var cw = W / 3, rh = H / 3;
        for (k = 0; k < word.length && k < 9; k++) {
          var ci = k % 3, ri = Math.floor(k / 3);
          s = sizeNow();
          var ok = false, t;
          for (t = 0; t < 60; t++) {
            x = ci * cw + 0.08 * cw + rnd() * Math.max(0.84 * cw - s * 0.75, 1);
            y = ri * rh + rnd() * Math.max(rh - s, 1);
            if (!blocked(x, y, s)) { ok = true; break; }
          }
          if (!ok) {
            // cell fully covered by the form: try anywhere down the same column
            for (t = 0; t < 60; t++) {
              x = ci * cw + 0.08 * cw + rnd() * Math.max(0.84 * cw - s * 0.75, 1);
              y = rnd() * Math.max(H - s, 1);
              if (!blocked(x, y, s)) break;
            }
          }
          html += span(px(x), y, s, word[k]);
        }
      }
    } else {
      // Margins (and phones): one copy of the word per band, one height slot per letter, alternating sides
      var col = isPolicy ? null : host.querySelector('.pip-col');
      var colL = W * 0.3, colR = W * 0.7;
      if (col) { var cr = col.getBoundingClientRect(); colL = cr.left - lr.left; colR = cr.right - lr.left; }
      var band = H / reps;
      for (b = 0; b < reps; b++) {
        var slots = shuffle(word.map(function (_, i) { return i; }));
        var slotH = band / word.length;
        for (k = 0; k < word.length; k++) {
          s = sizeNow();
          y = b * band + slots[k] * slotH + rnd() * Math.max(slotH - s * 0.6, 1) - s * 0.2;
          y = Math.max(0, Math.min(y, H - s));
          var left = ((k + b) % 2) === 0;
          var leftCss;
          if (narrow) {
            leftCss = px(0.02 * W + rnd() * Math.max(0.86 * W - s * 0.75, 1));
          } else if (isPolicy) {
            // text column is about 68rem wide and centred; keep 2.4rem clear of it and 1.6rem from the page edge
            var f = rnd().toFixed(3), lw = Math.round(s * 0.75);
            var room = 'max(0px, 50% - 34rem - 2.4rem - 1.6rem - ' + lw + 'px)';
            leftCss = left ? 'calc(1.6rem + ' + room + ' * ' + f + ')' : 'calc(50% + 34rem + 2.4rem + ' + room + ' * ' + f + ')';
          } else {
            var lo = left ? 16 : colR + 24;
            var hi = left ? colL - 24 - s * 0.75 : W - 16 - s * 0.75;
            if (hi - lo < 20) { lo = left ? 8 : W * 0.86; hi = left ? W * 0.12 : W * 0.95 - s * 0.75; }
            leftCss = px(lo + rnd() * Math.max(hi - lo, 1));
          }
          html += span(leftCss, y, s, word[k]);
        }
      }
    }
    layer.innerHTML = html;
    layer.classList.add('is-ready');
  }

  function policySetup() {
    var box = document.querySelector('.shopify-policy__container');
    if (!box) return;
    if (!box.querySelector('.paladin-drift')) {
      var layer = document.createElement('div');
      layer.className = 'paladin-drift paladin-drift--policy';
      layer.setAttribute('aria-hidden', 'true');
      layer.setAttribute('data-word', 'POLICIES');
      layer.setAttribute('data-mode', 'margins');
      box.insertBefore(layer, box.firstChild);
    }
    var body = box.querySelector('.shopify-policy__body');
    if (body) {
      Array.prototype.slice.call(body.querySelectorAll('strong')).forEach(function (s) {
        var tx = (s.textContent || '').trim();
        if (!/^(OVERVIEW|SECTION\s+\d+)/.test(tx) || s.classList.contains('pd-pol-h')) return;
        s.classList.add('pd-pol-h');
        var nx = s.nextSibling;
        while (nx && nx.nodeType === 3 && !nx.textContent.trim()) nx = nx.nextSibling;
        if (nx && nx.nodeName === 'BR') nx.parentNode.removeChild(nx);
        var pv = s.previousSibling, removed = 0;
        while (pv && removed < 3) {
          var prev = pv.previousSibling;
          if (pv.nodeName === 'BR') { pv.parentNode.removeChild(pv); removed++; }
          else if (!(pv.nodeType === 3 && !pv.textContent.trim())) break;
          pv = prev;
        }
      });
    }
    box.classList.add('pd-pol-ready');
  }

  function placeAll() {
    Array.prototype.slice.call(document.querySelectorAll('.paladin-drift')).forEach(function (l) {
      // Policy pages: the layer starts at the very top of the page (20 Oct; it used to start below the title)
      if (l.classList.contains('paladin-drift--policy')) l.setAttribute('data-top', '0');
      place(l);
    });
  }

  var lastW = 0, timer;
  function init() {
    policySetup();
    if (!document.querySelector('.paladin-drift')) return;
    placeAll();
    lastW = window.innerWidth;
    window.addEventListener('load', placeAll);
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (Math.abs(window.innerWidth - lastW) > 1) { lastW = window.innerWidth; placeAll(); }
      }, 200);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
